import React from 'react';
import { CSVLink } from 'react-csv';
import { publishErrorNotification } from '@nbx/frontend-helpers/publish';
import Heading from 'components/shared/Heading';
import Text from 'components/shared/Text';
import Select from 'components/shared/Select';
import ButtonPrimary from 'components/shared/ButtonPrimary';
import useMarkets from 'hooks/useMarkets';
import { NBXAdmins } from 'services';
import styles from './styles.module.scss';

const headers = [
  { label: 'Created At', key: 'createdAt' },
  { label: 'Price', key: 'price' },
  { label: 'Quantity', key: 'quantity' },
  { label: 'Maker Order Side', key: 'makerOrderSide' },
  { label: 'Maker Order ID', key: 'makerOrderId' },
  { label: 'Maker Account ID', key: 'makerOrderAccountId' },
  { label: 'Taker Order Side', key: 'takerOrderSide' },
  { label: 'Taker Order ID', key: 'takerOrderId' },
  { label: 'Taker Account ID', key: 'takerOrderAccountId' }
];

const AdminReport = () => {
  const [reportData, setReportData] = React.useState([]);
  const [selectedMarket, selectMarket] = React.useState('BTC-NOK');
  const [options, setOptions] = React.useState({});
  const [loading, setLoading] = React.useState(false);
  const csvLinkRef = React.useRef(null);
  const markets = useMarkets({ disabled: true });

  React.useEffect(() => {
    if (!markets.loading && !markets.error) {
      const marketOptions = {};
      markets.data.forEach(market => {
        marketOptions[market.id] = {
          label: market.name,
          icon: { asset: market.baseCurrency }
        };
      });
      setOptions(marketOptions);
    }
  }, [markets.data, markets.loading, markets.error]);

  const downloadHistory = async () => {
    try {
      setLoading(true);
      const history = await NBXAdmins.getAdminTradeHistory(selectedMarket);
      setReportData(history);
      setTimeout(() => {
        csvLinkRef.current.link.click();
        setLoading(false);
      }, 100);
    } catch (caughtError) {
      setLoading(false);
      publishErrorNotification(
        { message: 'Failed to fetch data for admin report, please try again.' },
        caughtError
      );
    }
  };

  return (
    <div>
      <br />
      <br />
      <Heading tag="h3">Admin Market Report</Heading>
      <Text tag="p">
        This report will contain the entire trade history of a given market, including the account IDs of the
        maker and taker for each order.
      </Text>
      <br />
      <div className={styles.selectContainer}>
        <Select
          id="market"
          name="Market"
          options={options}
          onChange={e => selectMarket(e.target.value)}
          value={selectedMarket}
          wrapperStyles={[styles.selectWrapper]}
        />
        <ButtonPrimary onClick={downloadHistory} loading={loading}>
          Download Report
        </ButtonPrimary>
        <CSVLink
          data={reportData}
          ref={csvLinkRef}
          headers={headers}
          filename={`${selectedMarket} History Report - ${new Date().toISOString()}.csv`}
          separator=";"
        />
      </div>
    </div>
  );
};

export default AdminReport;
